/**
 * /execution/summary — read-only OperationalSummaryTile wrapped in a page shell.
 */
import { CockpitPage } from "@/components/cockpit/CockpitPage";
import { OperationalSummaryTile } from "@/components/observability/OperationalSummaryTile";
import { useRole } from "@/data/RoleContext";
import { canAccessExecutionDomain } from "@/data/executionDomain";

export default function ExecutionSummaryPage() {
  const { role } = useRole();
  if (!canAccessExecutionDomain(role)) return null;
  return (
    <CockpitPage title="Operational Summary" maxWidth="7xl">
      <OperationalSummaryTile />
    </CockpitPage>
  );
}
